import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import { useAppSelector } from 'store/store';
import {
  getFeatureFlagByNameSelector,
  headerClientLoadingSelector,
  progressiveHeaderClientLoadingSelector,
} from 'store/selectors';
import { showPreSaytDrawerSelector, showSaytDrawerSelector } from 'store/selectors/saytSelector';
import { TrendingSearch } from 'types';
import TrendingSearches from './TrendingSearches';
import TrendingSearchesPending from './TrendingSearchesPending';

interface TrendingSearchesContainerProps {
  trendingSearchData: TrendingSearch | null | undefined;
  showTrendingSearchData: boolean;
  isPersonalizationLoading: boolean;
}

const TrendingSearchesContainer = ({
  trendingSearchData,
  showTrendingSearchData,
  isPersonalizationLoading,
}: TrendingSearchesContainerProps) => {
  const showPreSaytDrawer = useAppSelector(showPreSaytDrawerSelector);
  const showSaytDrawer = useAppSelector(showSaytDrawerSelector);
  const progressiveHeaderDesktopEnabled = useAppSelector(
    getFeatureFlagByNameSelector('progressiveTaxoDesktop'),
  );
  const headerIsLoading = useAppSelector(headerClientLoadingSelector);
  const progressiveIsLoading = useAppSelector(progressiveHeaderClientLoadingSelector);
  const isHomrLoading = progressiveHeaderDesktopEnabled ? progressiveIsLoading : headerIsLoading;

  if (!showTrendingSearchData) {
    return null;
  }

  const saytDrawerOpen = showPreSaytDrawer || showSaytDrawer;
  if (saytDrawerOpen) {
    return null;
  }

  if (!trendingSearchData && (isHomrLoading || isPersonalizationLoading)) {
    return <TrendingSearchesPending />;
  }

  if (!trendingSearchData) {
    throw new Error(
      'Homr did not return any trendingSearches content. Make sure the correct data is being returned! ',
    );
  }

  return (
    <ErrorBoundaryWithLogger componentId="Header-TrendingSearches">
      <TrendingSearches content={trendingSearchData} />
    </ErrorBoundaryWithLogger>
  );
};

export default TrendingSearchesContainer;
